import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ua-wizard-stepper',
  templateUrl: './wizard-stepper.component.html',
  styleUrls: ['./wizard-stepper.component.scss'],
})
export class WizardStepperComponent implements OnInit {
  steps = [
    { id: 1, name: 'Planning', active: true },
    { id: 2, name: 'Details', active: false },
    { id: 3, name: 'Checkout', active: false },
  ];

  @Input() currentStep = 1;
  @Input() disabledSelect = false;
  @Output() stepChange = new EventEmitter<number>();

  ngOnInit(): void {
    this.steps.forEach((step) => (step.active = step.id === this.currentStep));
  }
  selectStep(stepId: number): void {
    if (!this.disabledSelect) {
      this.steps.forEach((step) => (step.active = step.id === stepId));
      this.stepChange.emit(stepId);
    }
  }
}
